import { useAppSelector } from "../hooks";

export function useAuthFlow() {
  return useAppSelector((state) => state.AuthFlow);
}

